import { render, staticRenderFns } from "./FinancialTips.vue?vue&type=template&id=4d71a40c&scoped=true"
import script from "./FinancialTips.vue?vue&type=script&lang=js"
export * from "./FinancialTips.vue?vue&type=script&lang=js"
import style0 from "./FinancialTips.vue?vue&type=style&index=0&id=4d71a40c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d71a40c",
  null
  
)

export default component.exports